import { getFontFamily } from "./fonts"

export function escapeHtml(text) {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}

export function renderTextElement(el) {
  const fontFamily = getFontFamily(el.font)
  const styles = [
    `font-family: ${fontFamily}`,
    `font-size: ${el.fontSize || 14}pt`,
    `color: ${el.color || '#333333'}`,
    `text-align: ${el.align || 'left'}`
  ]
  if (el.fontWeight) styles.push(`font-weight: ${el.fontWeight}`)
  if (el.fontStyle) styles.push(`font-style: ${el.fontStyle}`)

  return `<div style="${styles.join('; ')}">${escapeHtml(el.content || 'Text')}</div>`
}

export function renderEventDetailsElement(el, eventData) {
  const parts = []
  const color = el.color || '#333333'
  const { title, date, time, location, hostName } = eventData

  if (el.showTitle) {
    parts.push(`<div style="font-size: 16pt; font-weight: bold; margin-bottom: 8px; color: ${color}">${escapeHtml(title)}</div>`)
  }
  if (el.showDate) {
    parts.push(`<div style="font-size: 11pt; margin-bottom: 4px; color: ${color}"><strong>When:</strong> ${escapeHtml(date)} at ${escapeHtml(time)}</div>`)
  }
  if (el.showLocation) {
    parts.push(`<div style="font-size: 11pt; margin-bottom: 4px; color: ${color}"><strong>Where:</strong> ${escapeHtml(location)}</div>`)
  }
  if (el.showHost) {
    parts.push(`<div style="font-size: 11pt; margin-top: 8px; color: ${color}">Hosted by ${escapeHtml(hostName)}</div>`)
  }

  return parts.join('')
}

export function renderImageElement(el) {
  if (el.url) {
    return `<img src="${el.url}" style="width: 100%; height: 100%; object-fit: cover; pointer-events: none;" draggable="false" />`
  }
  return `<div class="bg-gray-200 flex items-center justify-center h-full text-gray-500 text-sm">No image</div>`
}

export function renderShapeElement(el) {
  const styles = [
    `width: 100%`,
    `height: 100%`,
    `background: ${el.fill || 'transparent'}`,
    `border: ${el.borderWidth || 0}px solid ${el.borderColor || 'transparent'}`
  ]
  if (el.shape === 'circle') styles.push('border-radius: 50%')
  if (el.opacity !== undefined) styles.push(`opacity: ${el.opacity}`)

  return `<div style="${styles.join('; ')}"></div>`
}

export function renderQrPlaceholder(el) {
  return `
    <div class="w-full h-full border-2 border-dashed border-gray-400 flex items-center justify-center bg-gray-100 text-xs text-gray-500">
      QR Code
    </div>
  `
}

export function getElementTypeName(el) {
  const typeNames = {
    text: "Text",
    event_details: "Event",
    image: "Image",
    shape: "Shape",
    qr_placeholder: "QR"
  }
  return typeNames[el.type] || "Element"
}

export function getElementPreview(el) {
  switch (el.type) {
    case "text": return (el.content || "").substring(0, 20)
    case "event_details": return "Details"
    case "image": return "Photo"
    case "shape": return el.shape || "rect"
    default: return ""
  }
}
